export const listing_carousal_page_offset = 10;

export const min_listing_carousal_count = 35;
